// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DonateFAQ_wrapper__4XCeH","footer":"DonateFAQ_footer__5qRIz","link":"DonateFAQ_link__SMvuE","section":"DonateFAQ_section__8D_Ks"};